import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, motion } from 'framer-motion';
import type React from 'react';
import type { HTMLAttributes } from 'react';
type AnimatedContainerProps = HTMLAttributes<HTMLDivElement> & {
  isExpanded: boolean;
  children: React.ReactNode;
};
const AnimatedContainer = t0 => {
  const $ = _c(5);
  const {
    isExpanded,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== isExpanded) {
    t1 = isExpanded && <motion.div initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: "auto",
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }}>{isExpanded ? children : null}</motion.div>;
    $[0] = children;
    $[1] = isExpanded;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <AnimatePresence>{t1}</AnimatePresence>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default AnimatedContainer;